import { Checkbox, Grid, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { Link, useLocation } from 'react-router';
import { HashLink } from 'react-router-hash-link';

import Modal from '../../components/Modal';
import { scrollWithOffset } from '../../helpers/scrollWithOffset';
import useAppContext from '../../hooks/useAppContext';
import useMarkdownFile from '../../hooks/useMarkdownFile';
import cookieBanner from '../../markdowns/cookieBanner.md';

const CookieBanner = () => {
  const intl = useIntl();
  const { pathname } = useLocation();
  const { cookiesAccepted, setCookiesAccepted } = useAppContext();
  const { markdownContent } = useMarkdownFile(cookieBanner);
  const [confirmChecked, setConfirmChecked] = useState(false);
  const [dismissModalOpened, setDismissModalOpened] = useState(false);

  const excludedPaths = useMemo(() => ['/data-privacy', '/about-us'], []);
  const showCookieBanner = useMemo(
    () =>
      !cookiesAccepted &&
      !dismissModalOpened &&
      !excludedPaths.includes(pathname) &&
      markdownContent,
    [cookiesAccepted, dismissModalOpened, excludedPaths, pathname, markdownContent]
  );

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    setConfirmChecked(checked);
    if (checked) {
      setCookiesAccepted?.(true);
    }
  };

  const renderLinks = useMemo(
    () => (
      <Grid
        container
        justifyContent='space-between'
        gap={2}
      >
        <Grid item>
          <Link to='/data-privacy'>
            <Typography>Privacy Policy</Typography>
          </Link>
        </Grid>
        <Grid item>
          <Link to='/about-us'>
            <Typography>Imprint</Typography>
          </Link>
        </Grid>
        <Grid item>
          <HashLink
            to='/data-privacy#partner-list'
            scroll={scrollWithOffset}
          >
            <Typography>Partner List (2)</Typography>
          </HashLink>
        </Grid>
      </Grid>
    ),
    []
  );

  return (
    showCookieBanner && (
      <Modal
        open
        title={intl.formatMessage({ id: 'cookieBannerTitle' })}
        hideActions
        onClose={() => {
          setDismissModalOpened(true);
        }}
        width='auto'
      >
        <Grid
          container
          direction='column'
          spacing={2}
        >
          <Grid item>{markdownContent}</Grid>
          <Grid item>
            <Grid
              container
              alignItems='center'
              spacing={1}
            >
              <Grid item>
                <Checkbox
                  checked={confirmChecked}
                  onChange={handleCheckboxChange}
                />
              </Grid>
              <Grid
                item
                xs
              >
                <Typography component='span'>
                  {intl.formatMessage({ id: 'cookieBannerCheckboxMessage1' })}
                  <Link to='/data-privacy'>
                    <Typography
                      component='span'
                      display='inline'
                    >
                      Privacy Policy
                    </Typography>
                  </Link>
                  {intl.formatMessage({ id: 'cookieBannerCheckboxMessage2' })}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            sx={{ mt: 2 }}
          >
            {renderLinks}
          </Grid>
        </Grid>
      </Modal>
    )
  );
};

export default CookieBanner;
